export default "/images/ASCO.png?06be45a0d79b8120c23c6571ded7713f";